import DataTable from '../../../../../components/Datatable';
import Loading from '../../../../../components/Loading';
import { COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { query } from './query';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';

class UrlPlatformOverlap extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);

        this.state = {
            data: [],
            loading: true,
            totalMentions: 1,
        };
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                platforms: this.props.platforms,
            });

            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const data = results?.map((x) => ({ id: uuid(), ...x }));

            this.setState({
                data,
                loading: false,
            });
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }
        if (JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids)) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.domain?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;
        const columns = COLUMNS(t);

        return (
            <div className="card table-main rounded-main ">
                {this.state.loading && <Loading padding={10} />}
                {!this.state.loading && (
                    <DataTable
                        nodes={this.state.data ?? []}
                        sortFns={getSortKeys(columns)}
                        searchFunction={this.searchFunction}
                        COLUMNS={columns}
                        header={t('ai_tracking.keyword_detail.url_platform_overlap.header')}
                        customEmptyMessage={t('global.no_data')}
                        forceRun={this.forceRun}
                        additionalStyles={setAdditionalStyles(columns)}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(UrlPlatformOverlap);
